import gsap from "gsap";

/**
 * Single authoritative pose controller — latest setPose() always wins.
 * Kills competing opacity tweens across all pose images.
 */
export const createPoseController = (posesRef, brokenRef, { duration = 0.35 } = {}) => {
    let generation = 0;
    let activeIndex = 0;

    const killAll = () => {
        posesRef.current.forEach((img) => {
            if (img) gsap.killTweensOf(img);
        });
    };

    const applyInstant = (targetIndex) => {
        posesRef.current.forEach((img, i) => {
            if (img) gsap.set(img, { opacity: i === targetIndex ? 1 : 0 });
        });
    };

    const enforceActive = () => {
        applyInstant(activeIndex);
    };

    const setPose = (idx, instant = false) => {
        generation += 1;
        const gen = generation;
        activeIndex = brokenRef.current[idx] ? 0 : idx;

        killAll();

        if (instant) {
            applyInstant(activeIndex);
            return gen;
        }

        posesRef.current.forEach((img, i) => {
            if (!img) return;
            gsap.to(img, {
                opacity: i === activeIndex ? 1 : 0,
                duration,
                ease: "power1.out",
                overwrite: true,
                onComplete: () => {
                    if (gen !== generation) return;
                    enforceActive();
                },
            });
        });

        return gen;
    };

    return { setPose, killAll, enforceActive, getActiveIndex: () => activeIndex };
};
